module.exports = __webpack_public_path__ + "img/product_81.560ecff.svg";